import { Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

// Shared "How FOTA Works" trigger + modal, dropped into any page that deals
// with FOTA (Manual FOTA, FOTA Batch Details, FOTA Batch List) so the
// explanation only has to be maintained in one place. Content is traced
// against the actual device-side state machine (tcu4g_ota), batch/manual
// creation and priority rules (tcu4g_backend), and the AIS140-ticket auto
// batch trigger (ticketingTool.controller.js) - see the diagrams' own
// captions for the specific behavior each box/arrow reflects.
@Component({
  selector: 'app-fota-info',
  standalone: true,
  imports: [MatIcon, MatTooltip],
  templateUrl: './fota-info.component.html',
  styleUrl: './fota-info.component.scss',
})
export class FotaInfoComponent {
  isOpen = false;

  open(): void {
    this.isOpen = true;
  }

  close(): void {
    this.isOpen = false;
  }

  // Prints just this panel (see the @media print rules in
  // shared/styles/info-panel.scss) - the browser's own print dialog lets
  // the user pick "Save as PDF" as the destination, which avoids pulling
  // in a client-side PDF library just to rasterize what's already a clean
  // HTML/SVG document.
  exportPdf(): void {
    window.print();
  }
}
